import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../components/NTable";
import InfoModal from "./InfoModal";
import { useColumns } from "./columns";
import { useNewTable } from "../../../components/NTable/hook";
import useApi from "../../../utils/api";
import { useVisible } from "../../../utils/hooks/useVisible";
import "./style.scss";

function Batch() {
    const { t } = useTranslation();
    const { authGet } = useApi();
    const { visible, open, close, selected } = useVisible();
    const columns = useColumns({ open });

    const query = useQuery({
        queryKey: ["/schedules/bulk-jobs"],
        queryFn: ({ queryKey }: any) => {
            const [url] = queryKey;
            return authGet(url);
        }
    });

    const table = useNewTable({
        data: query.data?.result || [],
        columns,
        totalItems: query.data?.totalItems || 0,
        enableRowSelection: false,
        loading: query.isLoading
    } as any);

    return (
        <div className="tw-h-full tw-w-full tw-bg-white tw-rounded-lg">
            <h1 className="tw-p-5 tw-border-btw- mb-3">{t("batch-jobs")}</h1>

            <div className="batch-table-scroll">
                <Table
                    table={table}
                    hasChangedDateFilter={false}
                    setHasChangedDateFilter={() => { }}
                />
            </div>

            <InfoModal
                values={selected}
                isOpen={visible}
                close={close}
            />
        </div>
    );
};

export default Batch;
